import React, { useState } from 'react';
import { Container, Form, Button, Card, Alert } from 'react-bootstrap';
// import { loginUser } from '../api'; // Non più necessario importare direttamente loginUser qui
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import PasswordInput from '../components/PasswordInput';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [rememberMe, setRememberMe] = useState(false); // Nuovo stato
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { login, isAuthenticated } = useAuth(); // Prendiamo isAuthenticated per reindirizzare se già loggato
    const navigate = useNavigate();

    // Se l'utente è già autenticato, reindirizza alla home
    React.useEffect(() => {
        if (isAuthenticated) {
            navigate('/');
        }
    }, [isAuthenticated, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password, rememberMe); // Chiamiamo il login del contesto
            navigate('/');
        } catch (err) {
            setError(err.message || 'Login fallito. Si prega di verificare le credenziali.');
            console.error('Login error:', err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '100vh',
            backgroundImage: 'url(/assets/sfondo_login.jpg)', // Using relative path
            backgroundSize: 'cover',
            backgroundPosition: 'center',
        }}>
            <Container>
                <Card className="shadow-lg" style={{ maxWidth: '400px', margin: 'auto' }}>
                    <Card.Body className="p-4">
                        <h2 className="text-center mb-4">Accedi a MovieManager</h2>
                        {error && <Alert variant="danger">{error}</Alert>}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control
                                    type="email"
                                    placeholder="Inserisci email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicPassword">
                                <Form.Label>Password</Form.Label>
                                <PasswordInput
                                    placeholder="Password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                                    autoComplete="current-password"
                                />
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                <Form.Check
                                    type="checkbox"
                                    label="Ricordami"
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                />
                            </Form.Group>

                            <Button variant="primary" type="submit" className="w-100" disabled={loading}>
                                {loading ? 'Accesso in corso...' : 'Accedi'}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default Login;
